import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { tooltipTheme } from "../tooltipTheme";
export var TooltipBodyStyled = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: ", ";\n\n    // These are set to ensure the arrow calculations don't create an infinite loop due. See #468.\n    min-height: 8px;\n    min-width: 8px;\n\n    > *,\n    a {\n        color: ", ";\n    }\n"])), function (_ref) {
  var themeMode = _ref.themeMode;
  return tooltipTheme.padding.body(themeMode);
}, function (_ref2) {
  var themeMode = _ref2.themeMode;
  return tooltipTheme.textColor.title(themeMode);
});
//# sourceMappingURL=TooltipBodyStyled.js.map